import { render, staticRenderFns } from "./ProfileMembersView.vue?vue&type=template&id=6dc89b7a&scoped=true"
import script from "./ProfileMembersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileMembersView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileMembersView.vue?vue&type=style&index=0&id=6dc89b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc89b7a",
  null
  
)

export default component.exports